import { signal } from "@preact/signals-react"

import { PRICING_CONFIG_MODES } from "./@constants"


export const pricingConfigMode = signal(PRICING_CONFIG_MODES.RETAILER)

// What the customer's reference price is **today**, from `/setup`: the derived mode, the role
// breakdown and the user counts. The selector opens on this instead of on a default, and the warning
// compares against it to say how many users a change would move.
export const customerSetup = signal(null)

// Changing the mode changes `DIPI_USER.role`, so it is gated behind an explicit acknowledgment.
export const modeChangeAcknowledged = signal(false)

export const mainSitesData = signal([])
export const rrspData = signal([])

export const isConfigEmpty = signal(false)
export const reloadPricingConfigData = signal(false)
// Set after saving a role change: the roles moved, so the summary and the preselected mode are stale.
export const reloadCustomerSetup = signal(false)

// Drawer state: an empty object means closed, exactly like `keywordFilters` in
// Management/KeywordsCrud. Holding the row being edited doubles as the form's initial value.
export const mainSiteFormFilters = signal({})
export const rrspFormFilters = signal({})

// Every row the admin has touched in this session. The write endpoint does not exist yet
// (`plans/admin-pricing-config.md` §7, fase 3), so drafts live here and the page says so out
// loud instead of pretending they were stored.
export const havePendingChanges = signal(false)

export const resetManagementPricingConfigSignals = () => {
    pricingConfigMode.value = PRICING_CONFIG_MODES.RETAILER
    customerSetup.value = null
    modeChangeAcknowledged.value = false
    mainSitesData.value = []
    rrspData.value = []
    isConfigEmpty.value = false
    reloadPricingConfigData.value = false
    reloadCustomerSetup.value = false
    mainSiteFormFilters.value = {}
    rrspFormFilters.value = {}
    havePendingChanges.value = false
}
